import React, { useContext, useState } from 'react'
import ProfileIcon from 'components/ProfileIcon'
import SingleDot from 'assets/icons/single-dot'
import { CommentSectionContainer, CommentAligmentItems } from './style'
import ReadMore from 'components/ReadMore'
import ActionsMenu from 'features/ActionMenu'
import EditIcon from 'assets/icons/edit-icon'
import RemoveIcon from 'assets/icons/remove-icon'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import { removeReplyCopy2 } from 'api/site'
import { SiteContext } from 'providers/site'
import UpdateFormReply from 'flow/siteProposal/components/comments/updateFormReply'
import Modal from 'components/Modal'
import RemoveCommentModal from 'flow/siteProposal/components/comments/removeCommentModal/removeCommentModal'
import { useParams } from 'react-router-dom'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { editOnly } from 'routing/constants'

const MAX_COMMENT_PREVIEW_LENGTH = 240

const ReplyItem = ({
  profile,
  text = "", 
  createdAt,
  updatedAt,
  commentId,
  getReplyData,
}) => {
  const params = useParams();
  const [isPressedEditComment, setIsPressedEditComment] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { site } = useContext(SiteContext);
  const dateCreated = Date.parse(createdAt);
  const dateUpdated = Date.parse(updatedAt);
  const actualDate = new Date()
  const timeAgo = actualDate - dateUpdated

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;

  TimeAgo.addDefaultLocale(en)
  const ago = new TimeAgo('en-US')
  const time = ago.format(Date.now() - timeAgo)

  const deleteReply = async () => {
    try {
      await removeReplyCopy2(site.id, commentId, params.siteHistoryId, {}, editOnlySite);
      await getReplyData();
    } catch (error) {
      throw error;
    }
  };

  // Dropdown menu items
  const dropdownItems = [
    {
      icon: <EditIcon />,
      title: "editComment",
      onClick: () => setIsPressedEditComment((state) => !state),
    },
    {
      icon: <RemoveIcon />,
      title: "remove",
      onClick: () => setIsOpen(true),
    },
  ];

  return (
    <CommentSectionContainer>
      <CommentAligmentItems>
        <div style={{ display: "flex" }}>
          <ProfileIcon user={profile} isInCommentSection />
          <div
            style={{
              display: "flex",
              padding: "0 13px",
              alignItems: "center",
            }}
          >
            <SingleDot />
            <div
              style={{
                paddingLeft: "13px",
                color: "rgba(32, 32, 32, 0.7)",
              }}
            >
              {dateUpdated === dateCreated ? time : `${time} (edited)`}
            </div>
          </div>
        </div>
        <ActionsMenu dropdownItems={dropdownItems} />
      </CommentAligmentItems>

      <Modal
        isOpen={isOpen}
        toggleModal={setIsOpen}
        modalTitleId="removeComment"
        label="leaveComment"
        padding="8px"
        bottomBorder={false}
        paddingBottom="0"
        justifyContent="center"
      >
        <RemoveCommentModal
          closeModal={() => setIsOpen(false)}
          confirmRemove={deleteReply}
        />
      </Modal>

      {!isPressedEditComment ? (
        <ReadMore text={text} maxLength={MAX_COMMENT_PREVIEW_LENGTH} />
      ) : (
        <UpdateFormReply
          setEditComment={setIsPressedEditComment}
          getReplyData={getReplyData}
          commentId={commentId}
          text={text}
        />
      )}
    </CommentSectionContainer>
  );
};

export default ReplyItem;
